import script from "./CookieConsentBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./CookieConsentBanner.vue?vue&type=script&setup=true&lang=js"

import "./CookieConsentBanner.vue?vue&type=style&index=0&id=1d21b7dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d21b7dd"]])

export default __exports__